export enum SubscriptionProductEnum {
    DocubirdProfessional = 1,
    DocubirdEssentials = 2,
    Service = 3
}